import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-688484e6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-briefcase me-2" }, null, -1))
const _hoisted_2 = { class: "px-3" }
const _hoisted_3 = { class: "mb-3" }
const _hoisted_4 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = {
  key: 0,
  class: "invalid-feedback d-inline",
  role: "alert"
}
const _hoisted_9 = ["disabled"]
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-trash-alt" }, null, -1))
const _hoisted_11 = ["disabled"]
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-ban" }, null, -1))
const _hoisted_13 = ["disabled"]
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "fas fa-save" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Datepicker = _resolveComponent("Datepicker")!
  const _component_BaseModalComponent = _resolveComponent("BaseModalComponent")!

  return (_openBlock(), _createBlock(_component_BaseModalComponent, {
    ref: "provinceTaskForm",
    backdrop: "static",
    onHide: _ctx.clearForm
  }, {
    title: _withCtx(() => [
      _hoisted_1,
      _createTextVNode(_toDisplayString(_ctx.title), 1)
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("label", {
            for: "emergencyDate",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.provinceTaskDate}])
          }, " วันที่รายงาน: ", 2),
          (_ctx.submited && _ctx.errors.provinceTaskDate)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, " * กรุณาเลือกวันที่รายงาน "))
            : _createCommentVNode("", true),
          _createVNode(_component_Datepicker, {
            modelValue: _ctx.formData.provinceTaskDate,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.formData.provinceTaskDate) = $event)),
            enableTimePicker: false,
            locale: "th-TH",
            format: "dd/MM/yyyy",
            weekStart: "0",
            position: "left",
            autoApply: "",
            placeholder: "กรุณาเลือกวันที่รายงาน...",
            class: _normalizeClass(["form-control p-0", {'is-invalid': _ctx.submited && _ctx.errors.provinceTaskDate}]),
            onChange: _ctx.unsubmit
          }, null, 8, ["modelValue", "class", "onChange"])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("label", {
            for: "name",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.name}])
          }, " ชื่อรายงาน: ", 2),
          (_ctx.submited && _ctx.errors.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, " * กรุณาป้อนชื่อรายงาน "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("input", {
            type: "text",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.name) = $event)),
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.name}]),
            placeholder: "กรุณาป้อนชื่อรายงาน...",
            "aria-label": "name",
            autocomplete: "off",
            onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, null, 34), [
            [
              _vModelText,
              _ctx.formData.name,
              void 0,
              { trim: true }
            ]
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("label", {
            for: "description",
            class: _normalizeClass(["form-label text-muted", {'is-invalid': _ctx.submited && _ctx.errors.description}])
          }, " รายละเอียด: ", 2),
          (_ctx.submited && _ctx.errors.description)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, " * กรุณาป้อนรายละเอียด "))
            : _createCommentVNode("", true),
          _withDirectives(_createElementVNode("textarea", {
            class: _normalizeClass(["form-control", {'is-invalid': _ctx.submited && _ctx.errors.description}]),
            placeholder: "กรุณาป้อนรายละเอียด...",
            "aria-label": "description",
            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.description) = $event)),
            onChange: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.unsubmit && _ctx.unsubmit(...args)))
          }, "\n          ", 34), [
            [_vModelText, _ctx.formData.description]
          ])
        ])
      ])
    ]),
    footer: _withCtx(() => [
      (_ctx.isEditMode)
        ? (_openBlock(), _createElementBlock("button", {
            key: 0,
            type: "button",
            class: "btn btn-danger me-auto",
            disabled: _ctx.isLoading,
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.deleteClick && _ctx.deleteClick(...args)))
          }, [
            _hoisted_10,
            _createTextVNode(" ลบ ")
          ], 8, _hoisted_9))
        : _createCommentVNode("", true),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        disabled: _ctx.isLoading,
        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.hide && _ctx.hide(...args)))
      }, [
        _hoisted_12,
        _createTextVNode(" ปิด ")
      ], 8, _hoisted_11),
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-primary",
        disabled: _ctx.isLoading,
        onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.submitClick && _ctx.submitClick(...args)))
      }, [
        _hoisted_14,
        _createTextVNode(" บันทึก ")
      ], 8, _hoisted_13)
    ]),
    _: 1
  }, 8, ["onHide"]))
}